import type { Experiments } from '@wix/thunderbolt-symbols'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

export function isSeoHtmlOptimizationsEnabled(isInSEO: boolean, requestUrl: string): boolean {
	return isInSEO || requestUrl.includes('forceSeoHtmlOptimizations=true')
}

export function shouldOutlineCss(experiments: Experiments, isInSEO: boolean, requestUrl: string): boolean {
	return (
		isExperimentOpen(experiments, 'specs.thunderbolt.outlineCss') && isSeoHtmlOptimizationsEnabled(isInSEO, requestUrl)
	)
}
